import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Lock: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon=Lock">
      <path
        id="Vector"
        d="M9.23047 9.00012H7.2002C6.08009 9.00012 5.51962 9.00012 5.0918 9.21811C4.71547 9.40986 4.40973 9.71559 4.21799 10.0919C4 10.5197 4 11.0802 4 12.2003V17.8003C4 18.9204 4 19.4802 4.21799 19.908C4.40973 20.2843 4.71547 20.5906 5.0918 20.7823C5.5192 21.0001 6.07902 21.0001 7.19694 21.0001H16.8031C17.921 21.0001 18.48 21.0001 18.9074 20.7823C19.2837 20.5906 19.5905 20.2843 19.7822 19.908C20 19.4806 20 18.9216 20 17.8037V12.197C20 11.0791 20 10.5193 19.7822 10.0919C19.5905 9.71559 19.2837 9.40986 18.9074 9.21811C18.4796 9.00012 17.9203 9.00012 16.8002 9.00012H14.7689M9.23047 9.00012H14.7689M9.23047 9.00012C9.10302 9.00012 9 8.8968 9 8.76935V6.00012C9 4.34327 10.3431 3.00012 12 3.00012C13.6569 3.00012 15 4.34327 15 6.00012V8.76935C15 8.8968 14.8964 9.00012 14.7689 9.00012"
        stroke="currentColor"
        strokeWidth="currentStrokWidth"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Lock;
